import createIcon from '../../createIcon';

/**
 * @component @name FormatColorText
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxOC41SDIyVjIyLjVIMlYxOC41Wk01LjQ5IDE1LjVINy45MUw5LjE4IDExLjkySDE0LjgzTDE2LjA5IDE1LjVIMTguNTFMMTMuMjUgMS41SDEwLjc1TDUuNDkgMTUuNVpNOS45MSA5Ljg5TDExLjk0IDQuMUgxMi4wNkwxNC4wOSA5Ljg5SDkuOTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatColorText = createIcon('FormatColorText', [
  [
    'path',
    {
      d: 'M2 18.5H22V22.5H2V18.5ZM5.49 15.5H7.91L9.18 11.92H14.83L16.09 15.5H18.51L13.25 1.5H10.75L5.49 15.5ZM9.91 9.89L11.94 4.1H12.06L14.09 9.89H9.91Z',
      key: 'f457f7',
    },
  ],
]);

export default FormatColorText;
